// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
const CONST_VIEWED_NEWS = 'viewedNews';
const CONST_LAST_CONNECTION_NAME = 'lastConnectionName';
const CONST_TOKEN_FOR_PORTFOLIO = 'TokenForPortfolio';
const CONST_LOCAL_STORAGE_SELECTED_CARD = 'notifPanelSelCardID';
const CONST_LANGUAGE = 'language';
const CONST_CONNECTION_SETTINGS = 'cs';
const CONST_WM_DEFAULT_TRADING_LOTS = 'WMQty';
const CONST_WM_ACCOUNT_DETAILS_COLLAPSED_GROUPS = 'WMAccountDetailsCollapsedGroups';
class _LocalStorage {
    constructor() {
        this.credentialsStorage = {};
    }
    getViewedNews() {
        return localStorage.getItem(CONST_VIEWED_NEWS);
    }
    setViewedNews(jsonViewedNews) {
        localStorage.setItem(CONST_VIEWED_NEWS, jsonViewedNews);
    }
    getLastConnectionName() {
        return localStorage.getItem(CONST_LAST_CONNECTION_NAME);
    }
    setLastConnectionName(connectionName) {
        localStorage.setItem(CONST_LAST_CONNECTION_NAME, connectionName);
    }
    setTokenForPortfolio(token) {
        localStorage.setItem(CONST_TOKEN_FOR_PORTFOLIO, token);
    }
    getTokenForPortfolio() {
        return localStorage.getItem(CONST_TOKEN_FOR_PORTFOLIO);
    }
    removeTokenForPortfolio() {
        localStorage.removeItem(CONST_TOKEN_FOR_PORTFOLIO);
    }
    getNotificationPanelSelectedCards() {
        return localStorage.getItem(CONST_LOCAL_STORAGE_SELECTED_CARD);
    }
    setNotificationPanelSelectedCards(selectedId) {
        localStorage.setItem(CONST_LOCAL_STORAGE_SELECTED_CARD, selectedId);
    }
    getLanguage() {
        return localStorage.getItem(CONST_LANGUAGE);
    }
    setLanguage(language) {
        localStorage.setItem(CONST_LANGUAGE, language);
    }
    getCollapsedGroupsForWMAccountDetails() {
        return localStorage.getItem(CONST_WM_ACCOUNT_DETAILS_COLLAPSED_GROUPS);
    }
    setCollapsedGroupsForWMAccountDetails(groupsIDs) {
        localStorage.setItem(CONST_WM_ACCOUNT_DETAILS_COLLAPSED_GROUPS, groupsIDs);
    }
    saveDefaultTradingLots(qtyAndCashValueForWMString) {
        localStorage.setItem(CONST_WM_DEFAULT_TRADING_LOTS, qtyAndCashValueForWMString);
    }
    getDefaultTradingLots() {
        return localStorage.getItem(CONST_WM_DEFAULT_TRADING_LOTS);
    }
    setConnectionSettings(connectionName, login, pass, customerNo) {
        const objTsave = {};
        if (login) {
            objTsave.u = login;
        }
        if (pass != null) {
            objTsave.ep = pass;
        }
        if (customerNo) {
            objTsave.cN = customerNo;
        }
        this.credentialsStorage[connectionName] = objTsave;
        localStorage.setItem(CONST_CONNECTION_SETTINGS, JSON.stringify(this.credentialsStorage));
    }
    getConnectionSettings(name) {
        const c = this.credentialsStorage[name];
        if (c != null) {
            const login = c.u || '';
            const encryptedPass = null; // c.ep ?? null; // commented out due to fix already saved passwords #122310 + #122295
            const customerNo = c.cN || '';
            return [login, encryptedPass, customerNo];
        }
        return ['', null, ''];
    }
    loadConnectionSettings() {
        try {
            const cs = localStorage.getItem(CONST_CONNECTION_SETTINGS);
            if (!cs) {
                const lcn = localStorage.getItem(CONST_LAST_CONNECTION_NAME);
                if (lcn) {
                    const u = localStorage.getItem('user') || '';
                    const cN = localStorage.getItem('customerNo') || '';
                    const nD = {};
                    const objts = { u };
                    if (cN) {
                        objts.cN = cN;
                    }
                    nD[lcn] = objts;
                    this.credentialsStorage = nD;
                }
                localStorage.removeItem('user');
                localStorage.removeItem('customerNo');
                localStorage.setItem(CONST_CONNECTION_SETTINGS, JSON.stringify(this.credentialsStorage));
            }
            else {
                this.credentialsStorage = JSON.parse(cs);
            }
            localStorage.removeItem('pwd');
        }
        catch (ex) { }
    }
    removeConnectionSettings() {
        this.credentialsStorage = {};
        localStorage.removeItem(CONST_CONNECTION_SETTINGS);
    }
}
export const LocalStorage = new _LocalStorage();
